import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import Wait from '@react/react-spectrum/Wait'
import UploadAsset from '../Nav/UploadAsset'
import UploadAssetPreview from '../Nav/UploadAssetPreview'
import PsActions from './PsActions'

export default function PsActionsCustom () {
    const { dispatch, customFiles, wait, upload, isApiReady, group, uploadProgress } = useContext( EasybakeContext )
    if (isApiReady) {
        return <PsActions />
    }
    if (upload || !customFiles || customFiles && customFiles.length === 0) {
        return <React.Fragment>
            { wait && <div className="adobe-easybake-modal-loading">
                <Wait size="L" />
                {uploadProgress>0 ? <div>{`${__('uploading_file')} (${uploadProgress}%)`}</div> : <div>{__('uploading_file')}</div>}
            </div>}
            { !customFiles || customFiles && customFiles.length === 0 || customFiles && customFiles.length > 0 && customFiles.filter( file => file.assetType === 'image').length === 0 ? 
            <UploadAsset assetType="image" imageType="image/jpg,image/jpeg,image/png" /> : 
            <UploadAsset assetType="action" imageType=".atn" />}
        </React.Fragment>
    } else {
        return <UploadAssetPreview assetFiles={["image","action"]} />
    }
}
